import React from 'react'

import AuthBase from '../components/AuthBase'
import {useTranslation} from "react-i18next";
import {Header} from "../components/Header";
import {Container, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer";
import {isMobileOnly} from "react-device-detect";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FaRegFileVideo} from "react-icons/fa";
import zoomIcon from "../images/zoom.svg";
import styled from "@emotion/styled";
import sv from '../styles/marketing'
import AuthButton from "../components/AuthButton";
import {userService} from "../_services";
import {useSelector} from "react-redux";
import {history} from "../_helpers";

// STYLE ##########################################################

const Content = styled(`div`)`
    ${sv.flexColumn};
    flex: 1;
    max-width: 1200px;
    padding: 0 48px;
    margin-bottom: 64px;
    height: 100%;
    @media(max-width: 450px) {
        padding: 0 10px;
    }
`;

const ContentInstance = styled(`div`)`
    margin-top: 40px;
`;

const ContentLabel = styled(`div`)`
    padding-left: 20px;
    @media(max-width: 450px) {
        padding-left: 0px;
    }
`;

const ContentButtonWrapper = styled(`div`)`
    ${sv.flexCenter}
    margin-top: 20px;
`;

const ContentButton = styled('div')`
    font-size: 15px;
    ${sv.buttonBase};
    color: ${sv.colors.body};
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
    border: 1.5px ${sv.colors.body} solid;
    &:hover {
        box-shadow: 0 3px 6px rgba(0,0,0,.2);
    }
`;

const ContentButtonCol = styled(`div`)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: -8px;
    margin-right: 10px;
`;

const ContentButtonRow = styled(`div`)`
    display: flex;
    flex-direction: row;  
    margin-top: 2px;
    align-items: center;
`;

const ContentButtonIcon = styled(`div`)`
    padding-right: 2px;
`;

const ContentButtonZoomRow = styled(ContentButtonRow)`
    max-width: 50px;
    margin-left: -20px;
`;

const ZoomIcon = styled('img')`
    width: 100px;
`;

const ButtonZoomIcon = styled(ZoomIcon)`
    width: 100px;
    margin-top: -20px;
    margin-bottom: -20px;
`;

const LinkButton = styled('a')`
  text-align: center;
  text-decoration: underline;
  color: ${sv.colors.body};
  cursor: pointer;
`;

const Actions = styled(`div`)`
    margin-top: 24px;
    ${sv.flexRow};
    justify-content: center;
    align-items: center;
`;

const CancelButton = styled(AuthButton)`
    margin-right: 0;
`;

// COMPONENT ##########################################################

export function OrderGistGroup() {

    const {isConnectedToZoom} = useSelector(state => {
        const {users} = state;
        let isZoomAvailable = userService.isConnectedToZoom(users);
        return {
            isConnectedToZoom: isZoomAvailable
        };
    });

    const {t} = useTranslation();

    return (
        <StyledMedia>
            <Container isMobile={isMobileOnly}>

                <Header/>

                <AuthBase title={t('Order a Gist.')} maxWidth={'550px'}>
                    <Content>

                        {/* Order-Upload */}
                        <ContentInstance>
                            <ContentLabel>
                                {t("Have a media file you'd like to upload to Gist to host?")}
                            </ContentLabel>
                            <ContentButtonWrapper>
                                <ContentButton onClick={() => history.push("/order/upload")}>
                                    <FontAwesomeIcon icon={faPlus} style={{marginRight: 20}}/>
                                    <ContentButtonCol>
                                        {t("Gist from")}
                                        <ContentButtonRow>
                                            <ContentButtonIcon>
                                                <FaRegFileVideo size={22}/>
                                            </ContentButtonIcon>
                                            {t("file")}
                                        </ContentButtonRow>
                                    </ContentButtonCol>
                                </ContentButton>
                            </ContentButtonWrapper>
                        </ContentInstance>

                        {/* Order-Url */}
                        <ContentInstance>
                            <ContentLabel>
                                {t("Already have a video hosted somewhere else?")}
                            </ContentLabel>
                            <ContentButtonWrapper>
                                <ContentButton onClick={() => history.push("/order/url")}>
                                    <FontAwesomeIcon icon={faPlus} style={{marginRight: 20}}/>
                                    <ContentButtonCol>
                                        {t("Gist from")}
                                        <ContentButtonRow>
                                            <ContentButtonIcon>
                                                <FontAwesomeIcon icon={faLink} style={{marginRight: 5, marginLeft: 5}}/>
                                            </ContentButtonIcon>
                                            {t("url")}
                                        </ContentButtonRow>
                                    </ContentButtonCol>
                                </ContentButton>
                            </ContentButtonWrapper>
                        </ContentInstance>

                        {/* Order-Zoom */}

                        {/* if zoom available */}
                        { isConnectedToZoom &&
                        <ContentInstance>
                            <ContentLabel>
                                {t("Have meetings recorded on the Zoom cloud?")}
                            </ContentLabel>
                            <ContentButtonWrapper>
                                <ContentButton onClick={() => history.push('/order/zoom')}>
                                    <FontAwesomeIcon icon={faPlus} style={{marginRight: 20}}/>
                                    <ContentButtonCol>
                                        {t("Gist from")}
                                        <ContentButtonZoomRow>
                                            <ContentButtonIcon>
                                                <ButtonZoomIcon src={zoomIcon} alt="Zoom" style={{marginRight: 5, marginLeft: 5}}/>
                                            </ContentButtonIcon>
                                        </ContentButtonZoomRow>
                                    </ContentButtonCol>
                                </ContentButton>
                            </ContentButtonWrapper>
                        </ContentInstance>
                        }

                        {/* if zoom not available */}
                        { !isConnectedToZoom &&
                        <ContentInstance>
                            <ContentButtonWrapper>
                                <LinkButton onClick={() => history.push('/zoom/connect')}>
                                    <div>{t("Connect with Zoom to create Gists of your meeting Cloud Recordings")}</div>
                                    <ZoomIcon src={zoomIcon} alt="Zoom"/>
                                </LinkButton>
                            </ContentButtonWrapper>
                        </ContentInstance>
                        }

                    </Content>
                    <Actions>
                        <CancelButton cancel onClick={() => history.goBack()}>{t('Cancel')}</CancelButton>
                    </Actions>
                </AuthBase>
                <Footer/>
            </Container>
        </StyledMedia>
    )
}